import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../global-config'
import { urlResolverGetOffersCategoryPage } from '../../url-handling'

export const OrderEmptyOrdersBox: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="my-6 flex w-full flex-wrap justify-center gap-9 rounded-2xl border-light-primary-strong bg-light-primary-low px-4 py-6 tablet:my-0 tablet:mb-12">
      <h3 className="w-full text-center text-m text-dark-primary-strong">
        <FormattedMessage id="contact.ordersSection.description.noOrder" />
      </h3>
      <Button<'a'>
        className="w-full tablet:w-72"
        color="primary"
        data-qa-id="qa-id-help-center-find-product"
        href={urlResolverGetOffersCategoryPage(globalConfig)}
        size="medium"
        variant="outlined"
      >
        <FormattedMessage id="contact.ordersSection.cta.findProductsLabel" />
      </Button>
    </div>
  )
}
